export const openDialog = name => ({
  type: `${name}_DIALOG_OPEN`,
});

export const closeDialog = name => ({
  type: `${name}_DIALOG_CLOSE`,
});
